module.exports = __webpack_public_path__ + "img/cuttingWire.808bc02f.png";